var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import '../helper/polyfill';
import { MoveFocusInside } from 'react-focus-lock';
import FontPreloader from '../components/FontPreloader';
import { useEffect, useState, useRef } from 'react';
import '../styles/main.scss';
import 'mathlive';
import globalStore from '../store';
import GameController from './GameController';
import IwbSharePopup from '../components/IwbSharePopup';
import { DataContextProvider } from './DataContext';
import { fetchData } from '../helper/helper';
import { initializeAudio } from '../helper/audioHelper';
import { ShareCodeDataSource, LocalDataSource, fetchShareCodeData, recomputePageDiff, resolvePageBackground, } from '../middleware/jsonMiddleware';
import { formatShareCode } from '../helper/shareCode';
import { preloadAsBlob, getImageSrc } from '../helper/imageBlobCache';
import { preloadPdfBackground, getPdfPageDimensions } from '../components/BackgroundRenderer';
import customEventHandler from '../helper/customEvents';
import { BUSY_EVENT, getBusyCount } from '../helper/busyOverlay';
import { trackEvent, setAudienceContext, AnalyticsCategory } from '../helper/analytics';
import { t } from 'i18next';
var PlayerMainContainer = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = useState(false), fontLoad = _l[0], setFontLoad = _l[1];
    var _m = useState(false), jsonDataLoaded = _m[0], setJsonDataLoaded = _m[1];
    var loaderImgRef = useRef(null);
    // True once the passive-login check has already run for this load. Carried
    // into the share-code → IDM-URL redirect so the destination doesn't bounce
    // through /login/passive a second time.
    var passiveCheckedRef = useRef(false);
    // Busy overlay shown around screenshot capture + save/delete API calls.
    // Drives the count via the busyOverlay event bus so callers outside React
    // (or in modals not mounted under this tree) can still trigger it.
    var _o = useState(getBusyCount()), busyCount = _o[0], setBusyCount = _o[1];
    useEffect(function () {
        var handler = function (e) { return setBusyCount(e.count); };
        customEventHandler.addEventListener(BUSY_EVENT, handler);
        return function () { return customEventHandler.removeEventListener(BUSY_EVENT, handler); };
    }, []);
    var isBusy = busyCount > 0;
    var _p = globalStore.useStoreState(function (state) { return state.playerStore; }), gameLoaded = _p.gameLoaded, displayMode = _p.displayMode, contrast = _p.contrast, playerIconZoom = _p.playerIconZoom, pdfBackgroundLoading = _p.pdfBackgroundLoading, currentPage = _p.currentPage, pageData = _p.pageData, activityMeta = _p.activityMeta, canvasWidth = _p.canvasWidth, canvasHeight = _p.canvasHeight, isIDM = _p.isIDM, isSwp = _p.isSwp, shareCode = _p.shareCode, cachedRawData = _p.cachedRawData;
    // No production.json means the synthetic empty workspace carries no real
    // page dimensions (coordWidth/coordHeight fall back to the canvas size), so
    // fit-zoom must size to the PDF page rectangle alone.
    var hasProduction = !!((_b = (_a = cachedRawData === null || cachedRawData === void 0 ? void 0 : cachedRawData.production) === null || _a === void 0 ? void 0 : _a.save_state) === null || _b === void 0 ? void 0 : _b.workspaces);
    // Reflect the activity title in the browser tab / <title>. Only IDM/SWP
    // activities carry a real authored name; everything else (fresh workspace,
    // opened share code) must always read "Math MultiApp by MLC". Without this,
    // a non-IDM share code surfaces the stamped placeholder appName ("ida").
    useEffect(function () {
        if ((isIDM || isSwp) && (activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.title) && activityMeta.title !== '') {
            document.title = activityMeta.title;
        }
        else {
            document.title = 'Math MultiApp by MLC';
        }
    }, [isIDM, isSwp, activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.title]);
    var currentBg = (_d = (_c = pageData[currentPage - 1]) === null || _c === void 0 ? void 0 : _c.background) !== null && _d !== void 0 ? _d : '';
    var pdfExists = pageData.some(function (page) { var _a; return /\.pdf(\?|$)/i.test((_a = page === null || page === void 0 ? void 0 : page.background) !== null && _a !== void 0 ? _a : ''); });
    var hasPdfBackground = pdfExists && /\.pdf(\?|$)/i.test(currentBg);
    var showLoader = !gameLoaded || (hasPdfBackground && pdfBackgroundLoading);
    var _q = globalStore.useStoreActions(function (state) { return state.playerStore; }), setGameLoaded = _q.setGameLoaded, setIsIDM = _q.setIsIDM, setIsSwp = _q.setIsSwp, setShareCode = _q.setShareCode, setViewEditMode = _q.setViewEditMode, loadActivityData = _q.loadActivityData, checkAuth = _q.checkAuth, setZoomLevel = _q.setZoomLevel, updatePageData = _q.updatePageData;
    // Preload every PDF background in the deck the moment pageData lands, so
    // revisiting a page renders from the in-memory cache instead of re-fetching S3.
    // For IDM PDF pages, backfill bgOffset with actual PDF dimensions so the
    // fit-zoom can use real measurements. Non-IDM PDF pages use a fixed 50% zoom.
    useEffect(function () {
        if (!isIDM && !isSwp)
            return;
        pageData.forEach(function (page, index) {
            var bg = page === null || page === void 0 ? void 0 : page.background;
            if (!bg || !/\.pdf(\?|$)/i.test(bg))
                return;
            preloadPdfBackground(bg).then(function () {
                var _a, _b, _c, _d, _e, _f;
                var dims = getPdfPageDimensions(bg);
                if (!dims)
                    return;
                var existing = page.bgOffset;
                // Skip only if existing dims are real (not canvas-sized placeholders)
                if (existing &&
                    existing.pageWidth &&
                    existing.pageHeight &&
                    !(existing.pageWidth >= canvasWidth && existing.pageHeight >= canvasHeight)) {
                    return;
                }
                updatePageData({
                    pageIndex: index,
                    data: {
                        bgOffset: {
                            diffX: (_a = existing === null || existing === void 0 ? void 0 : existing.diffX) !== null && _a !== void 0 ? _a : 0,
                            diffY: (_b = existing === null || existing === void 0 ? void 0 : existing.diffY) !== null && _b !== void 0 ? _b : 0,
                            scaleX: (_c = existing === null || existing === void 0 ? void 0 : existing.scaleX) !== null && _c !== void 0 ? _c : 1,
                            scaleY: (_d = existing === null || existing === void 0 ? void 0 : existing.scaleY) !== null && _d !== void 0 ? _d : 1,
                            pageWidth: dims.width,
                            pageHeight: dims.height,
                            coordWidth: (_e = existing === null || existing === void 0 ? void 0 : existing.coordWidth) !== null && _e !== void 0 ? _e : 0,
                            coordHeight: (_f = existing === null || existing === void 0 ? void 0 : existing.coordHeight) !== null && _f !== void 0 ? _f : 0,
                        },
                    },
                });
            });
        });
    }, [isIDM, pageData, updatePageData]);
    // Preload every translated PDF background up front (e.g. all Spanish pages
    // under translations.es.pages), not just the active language's. Doing this as
    // soon as the deck lands means the first language switch renders instantly
    // from the in-memory cache instead of fetching S3 on the page already on
    // screen. preloadPdfBackground de-dupes, so re-runs are cheap.
    useEffect(function () {
        var translations = activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.translations;
        if (!translations)
            return;
        Object.keys(translations).forEach(function (lang) {
            pageData.forEach(function (page) {
                var bg = resolvePageBackground(page, lang, translations);
                if (bg && bg !== (page === null || page === void 0 ? void 0 : page.background) && /\.pdf(\?|$)/i.test(bg)) {
                    preloadPdfBackground(bg);
                }
            });
        });
    }, [pageData, activityMeta]);
    var _r = globalStore.useStoreActions(function (state) { return state.jsonDataStore; }), fetchJsonData = _r.fetchJsonData, fetchCardDecks = _r.fetchCardDecks;
    // Per-page diff recalculation (production JSON only):
    // PDF rasterised dims and workspace coord dims may differ per page, and the
    // PDF may not have been cached when mergePageData first ran. On every page
    // change we re-derive diffX/diffY from the live values and, if they differ
    // from what's baked into the page's widget positions, shift everything by
    // the delta so the page stays aligned with its actual PDF. The helper
    // returns the same page reference when no shift is needed, so the
    // updatePageData call is skipped in the steady state.
    //
    // Skipped entirely for share-code payloads, whose positions are already in
    // canvas-relative coords laid out for a known PDF view — re-shifting them
    // would double-shift.
    useEffect(function () {
        if (!gameLoaded)
            return;
        var pageIndex = currentPage - 1;
        var page = pageData[pageIndex];
        if (!page)
            return;
        var isShareCodePage = !!shareCode;
        if (isShareCodePage) {
            return;
        }
        var updated = recomputePageDiff(page, { canvasWidth: canvasWidth, canvasHeight: canvasHeight }, isShareCodePage);
        if (updated !== page) {
            updatePageData({ pageIndex: pageIndex, data: updated });
        }
    }, [gameLoaded, currentPage, pageData, canvasWidth, canvasHeight, shareCode, updatePageData]);
    // IDM/SWP PDF: fit-zoom so the whole page is visible on every page change.
    // The fit dimensions are the LARGER of the PDF page rectangle and the
    // authored workspace rectangle — when the workspace is bigger than the PDF
    // (widgets placed outside the page area, wider authoring canvas, etc.) we
    // need to zoom out enough that the workspace fits, not just the PDF.
    // Exception: with no production.json there is no real workspace rectangle
    // (coordWidth/coordHeight default to the canvas size), so fit to the PDF
    // page dimensions alone.
    var currentBgOffset = (_e = pageData[currentPage - 1]) === null || _e === void 0 ? void 0 : _e.bgOffset;
    // Depend on the bgOffset PRIMITIVE values, not the object reference. A
    // language switch re-merges pageData and produces a fresh bgOffset object
    // with identical geometry — depending on the object would re-fire this
    // effect and reset the user's zoom (page "resizing" on EN↔ES). The primitives
    // only change on a real page/geometry change, which is when we want to refit.
    var fitPageW = (_f = currentBgOffset === null || currentBgOffset === void 0 ? void 0 : currentBgOffset.pageWidth) !== null && _f !== void 0 ? _f : 0;
    var fitPageH = (_g = currentBgOffset === null || currentBgOffset === void 0 ? void 0 : currentBgOffset.pageHeight) !== null && _g !== void 0 ? _g : 0;
    var fitCoordW = (_h = currentBgOffset === null || currentBgOffset === void 0 ? void 0 : currentBgOffset.coordWidth) !== null && _h !== void 0 ? _h : 0;
    var fitCoordH = (_j = currentBgOffset === null || currentBgOffset === void 0 ? void 0 : currentBgOffset.coordHeight) !== null && _j !== void 0 ? _j : 0;
    // User's persisted view zoom for the current page (undefined when the page
    // was never explicitly zoomed). When present it both drives the restore
    // effect below and suppresses the automatic fit-zoom effects, so a saved
    // zoom level "holds" across reloads and page navigation.
    var savedPageZoom = (_k = pageData[currentPage - 1]) === null || _k === void 0 ? void 0 : _k.zoomLevel;
    // Restore a previously saved per-page zoom. Runs ahead of (and instead of)
    // the auto fit-zoom whenever the page carries an explicit user zoom.
    useEffect(function () {
        if (!gameLoaded || savedPageZoom == null)
            return;
        setZoomLevel(savedPageZoom);
    }, [gameLoaded, currentPage, savedPageZoom, setZoomLevel]);
    useEffect(function () {
        if (!gameLoaded || savedPageZoom != null)
            return;
        var fitW = hasProduction ? Math.max(fitPageW, fitCoordW) : fitPageW;
        var fitH = hasProduction ? Math.max(fitPageH, fitCoordH) : fitPageH;
        if (!fitW || !fitH || (fitW >= canvasWidth && fitH >= canvasHeight))
            return;
        var id = requestAnimationFrame(function () {
            var _a;
            var scrollEl = (_a = document.getElementById('wrapperDiv')) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (!scrollEl || scrollEl.clientWidth === 0 || scrollEl.clientHeight === 0)
                return;
            var fitZoom = Math.min(scrollEl.clientWidth / fitW, scrollEl.clientHeight / fitH);
            var zoom = Math.max(0.05, Math.floor(fitZoom * 1000) / 1000);
            setZoomLevel(zoom);
        });
        return function () { return cancelAnimationFrame(id); };
    }, [
        gameLoaded,
        currentPage,
        fitPageW,
        fitPageH,
        fitCoordW,
        fitCoordH,
        canvasWidth,
        canvasHeight,
        hasProduction,
        savedPageZoom,
        setZoomLevel,
    ]);
    // Non-IDM/SWP PDF: default to 50% zoom on every page change — unless the
    // page carries an explicit user zoom, which takes precedence.
    useEffect(function () {
        if (!gameLoaded || isIDM || isSwp || savedPageZoom != null)
            return;
        if (!/\.pdf(\?|$)/i.test(currentBg))
            return;
        setZoomLevel(0.5);
    }, [gameLoaded, isIDM, isSwp, currentPage, currentBg, savedPageZoom, setZoomLevel]);
    useEffect(function () {
        if (!fontLoad)
            return;
        // ── Runaway-loop guard ──────────────────────────────────────────────────
        // If the SPA is somehow rendering on /login/passive itself (because the
        // endpoint doesn't exist and the router catches it), the redirect logic
        // below would re-wrap the current URL on every render, producing the
        // deeply-nested %25%25%25… encoding seen on multiapp before the hold was
        // added.  Detect this and bail out to the root immediately.
        if (window.location.pathname.startsWith('/login/passive')) {
            window.location.replace('/');
            return;
        }
        // ── Environment hold ────────────────────────────────────────────────────
        // Skip the passive-login bounce for environments where the
        // /login/passive endpoint is not yet implemented:
        //   • localhost / 127.0.0.1 / [::1]  — local development
        //   • webhost.mitrmedia.com          — passive SSO not implemented on this host
        var isLocalhost = window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname === '[::1]' ||
            /^192\.168\.\d+\.\d+$/.test(window.location.hostname) ||
            /^10\.\d+\.\d+\.\d+$/.test(window.location.hostname) ||
            /^172\.(1[6-9]|2\d|3[01])\.\d+\.\d+$/.test(window.location.hostname);
        var isPassiveLoginHeld = isLocalhost ||
            window.location.hostname === 'webhost.mitrmedia.com' ||
            window.location.hostname === 'bs-local.com';
        if (isPassiveLoginHeld) {
            onInit();
            return;
        }
        var searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('passive_checked')) {
            // Returning from /login/passive — strip the one-time marker so that a
            // subsequent page refresh re-triggers the passive check, then continue
            // with the normal init flow.
            passiveCheckedRef.current = true;
            var cleaned = window.location.href.replace(/[?&]passive_checked=1$/, '');
            window.history.replaceState(null, '', cleaned);
            onInit();
        }
        else {
            // First load (or any refresh) — bounce through /login/passive first.
            // We append passive_checked=1 to the return URL so we can detect the
            // landing without using sessionStorage (which would survive a refresh).
            var currentUrl = window.location.href;
            var separator = currentUrl.includes('?') ? '&' : '?';
            var returnUrl = "".concat(currentUrl).concat(separator, "passive_checked=1");
            window.location.href = "".concat(window.location.origin, "/login/passive?redirect=").concat(encodeURIComponent(returnUrl));
        }
    }, [fontLoad]);
    // Clean up loader image once the loader is actually dismissed (after any
    // blocking PDF background has also finished) so we don't stop the GIF early.
    useEffect(function () {
        if (!showLoader && loaderImgRef.current) {
            // Clear the image src to stop GIF animation and free memory
            loaderImgRef.current.src = '';
            loaderImgRef.current.removeAttribute('src');
        }
    }, [showLoader]);
    // Clean up MathJax context menu elements and MathLive toggles to prevent memory leaks
    useEffect(function () {
        var cleanupMathElements = function () {
            // Remove MathJax context menu elements (including parent containers)
            var mathJaxElements = document.querySelectorAll('.CtxtMenu_InfoContent, .CtxtMenu_MenuClose, .CtxtMenu_InfoClose, ' +
                '[class*="CtxtMenu"], [id*="MathJax"], mjx-assistive-mml');
            mathJaxElements.forEach(function (element) {
                var _a;
                try {
                    // Remove the element and its parent if it's a menu container
                    var parent_1 = element.parentElement;
                    if (parent_1 &&
                        parent_1.className &&
                        typeof parent_1.className === 'string' &&
                        parent_1.className.includes('CtxtMenu')) {
                        (_a = parent_1.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(parent_1);
                    }
                    else if (element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                }
                catch (error) {
                    console.warn('Error removing MathJax menu element:', error);
                }
            });
            // Remove MathLive toggle elements (virtual keyboard and menu toggles)
            var mathLiveElements = document.querySelectorAll('.ML__toggles, .ML__virtual-keyboard-toggle, .ML__menu-toggle, ' +
                '[part*="virtual-keyboard-toggle"], [part*="menu-toggle"]');
            mathLiveElements.forEach(function (element) {
                try {
                    if (element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                }
                catch (error) {
                    console.warn('Error removing MathLive toggle element:', error);
                }
            });
        };
        // Clean up immediately on mount
        cleanupMathElements();
        // Periodic cleanup every 1 second
        var intervalId = setInterval(cleanupMathElements, 1000);
        // MutationObserver to catch Math elements as soon as they're added
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    var _a, _b;
                    if (node instanceof HTMLElement) {
                        // Check if the node or its children contain MathJax menu elements
                        if (node.className &&
                            typeof node.className === 'string' &&
                            node.className.includes('CtxtMenu')) {
                            try {
                                (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(node);
                            }
                            catch (error) {
                                console.warn('Error removing MathJax menu via observer:', error);
                            }
                        }
                        // Check for MathLive toggle elements
                        if (node.className &&
                            typeof node.className === 'string' &&
                            (node.className.includes('ML__toggles') ||
                                node.className.includes('ML__virtual-keyboard-toggle') ||
                                node.className.includes('ML__menu-toggle'))) {
                            try {
                                (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(node);
                            }
                            catch (error) {
                                console.warn('Error removing MathLive toggle via observer:', error);
                            }
                        }
                        // Also check descendants
                        var mathElements = node.querySelectorAll('[class*="CtxtMenu"], .ML__toggles, .ML__virtual-keyboard-toggle, .ML__menu-toggle');
                        mathElements.forEach(function (element) {
                            var _a;
                            try {
                                (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(element);
                            }
                            catch (error) {
                                console.warn('Error removing descendant Math element:', error);
                            }
                        });
                    }
                });
            });
        });
        // Start observing the document body for added nodes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return function () {
            clearInterval(intervalId);
            observer.disconnect();
            cleanupMathElements(); // Final cleanup on unmount
        };
    }, []);
    useEffect(function () {
        var updateOrientation = function () {
            var wrapper = document.getElementById('game-wrapper');
            var isPortrait = window.innerHeight > window.innerWidth;
            if (wrapper) {
                if (isPortrait) {
                    // Rotate game to landscape
                    wrapper.style.transform = "\n          translate(-50%, -50%)\n          rotate(90deg)\n        ";
                    wrapper.style.width = window.innerHeight + 'px';
                    wrapper.style.height = window.innerWidth + 'px';
                }
                else {
                    // Normal landscape
                    wrapper.style.transform = "\n          translate(-50%, -50%)\n          rotate(0deg)\n        ";
                    wrapper.style.width = window.innerWidth + 'px';
                    wrapper.style.height = window.innerHeight + 'px';
                }
            }
        };
        // window.addEventListener('resize', updateOrientation);
        // window.addEventListener('orientationchange', updateOrientation);
        // updateOrientation();
        return function () {
            window.removeEventListener('resize', updateOrientation);
            window.removeEventListener('orientationchange', updateOrientation);
        };
    }, [gameLoaded]);
    var onInit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var searchParams, _rawShareCode, shareCode, idmMapping, isIDMFlag, isLocalIDM, loadedActivityMeta, isLoggedIn, contentType, isShareable, res, body, payload, i, _a, _b, loggedIn, meta, loggedIn, redirect, hyphenatedCode, shareData, metaUrl, passiveMarker, _c, loggedIn, meta, _d, loggedIn, meta, _imageData, preloadImages, postloadImages, criticalPromises, trayCounterUrls, _i, _e, url, _audioObject, error_1, slug, code, activityRef, paths, CONCURRENCY, POSTLOAD_START_DELAY_MS, idle;
        var _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0: return [4 /*yield*/, fetchJsonData()];
                case 1:
                    _l.sent();
                    searchParams = new URLSearchParams(window.location.search);
                    _rawShareCode = searchParams.keys().next().value;
                    shareCode = _rawShareCode ? formatShareCode(_rawShareCode) : _rawShareCode;
                    idmMapping = window.__IDM_MAPPING__;
                    isIDMFlag = !!(idmMapping && idmMapping.revision_id);
                    isLocalIDM = searchParams.has('local-idm');
                    isLoggedIn = false;
                    contentType = 'free';
                    // When loading an activity that already has a share code, default to
                    // view mode so the user doesn't accidentally start editing the saved
                    // state. They can still toggle to Edit from the footer.
                    if (shareCode)
                        setViewEditMode('view');
                    if (!isLocalIDM) return [3 /*break*/, 3];
                    // Pretend we're in IDM mode so the pipeline (PDF preload, fit-zoom,
                    // share-code-aware merging) takes the IDM path. Skip auth — there's no
                    // backend to check against.
                    setIsIDM(true);
                    isLoggedIn = true;
                    contentType = 'IDM';
                    // Dev-only path: checkAuth (which normally sets audience context) is
                    // skipped here, so set it directly.
                    setAudienceContext({ isLoggedIn: isLoggedIn, contentType: contentType, userId: null });
                    return [4 /*yield*/, loadActivityData(new LocalDataSource())];
                case 2:
                    loadedActivityMeta = _l.sent();
                    return [3 /*break*/, 20];
                case 3:
                    if (!isIDMFlag) return [3 /*break*/, 15];
                    isShareable = false;
                    _l.label = 4;
                case 4:
                    _l.trys.push([4, 8, , 9]);
                    return [4 /*yield*/, fetch("/initial-json/".concat(idmMapping.revision_id), {
                            credentials: 'include',
                            redirect: 'manual',
                        })];
                case 5:
                    res = _l.sent();
                    if (!res.ok) return [3 /*break*/, 7];
                    return [4 /*yield*/, res.json().catch(function () { return null; })];
                case 6:
                    body = _l.sent();
                    payload = body;
                    for (i = 0; i < 5; i++) {
                        if (!payload || typeof payload !== 'object')
                            break;
                        if ('pages' in payload)
                            break;
                        if (payload.data && typeof payload.data === 'object') {
                            payload = payload.data;
                            continue;
                        }
                        break;
                    }
                    isShareable = !!(payload === null || payload === void 0 ? void 0 : payload.shareable);
                    _l.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    _a = _l.sent();
                    return [3 /*break*/, 9];
                case 9:
                    if (!isShareable) return [3 /*break*/, 11];
                    // SWP mode: same endpoints as IDM, but shareable.
                    //
                    // SWP never forces an active /login redirect — with or without a share
                    // code it loads the activity regardless of auth state. The passive
                    // login check (the /login/passive bounce in the fontLoad effect above)
                    // still runs for SWP, so an already-authenticated session is picked up
                    // silently; checkAuth here only tells us whether to enable save/share
                    // features. (The active /login redirect is IDM-only.)
                    setIsSwp(true);
                    contentType = 'SWP';
                    if (shareCode)
                        setShareCode(shareCode);
                    return [4 /*yield*/, Promise.all([checkAuth(), loadActivityData()])];
                case 10:
                    _b = _l.sent(), loggedIn = _b[0], meta = _b[1];
                    isLoggedIn = loggedIn;
                    loadedActivityMeta = meta;
                    return [3 /*break*/, 14];
                case 11:
                    // IDM mode: login always required.
                    setIsIDM(true);
                    contentType = 'IDM';
                    if (shareCode)
                        setShareCode(shareCode);
                    return [4 /*yield*/, checkAuth()];
                case 12:
                    loggedIn = _l.sent();
                    if (!loggedIn) {
                        redirect = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
                        window.location.href = "".concat(window.location.origin, "/login?redirect=").concat(redirect);
                        return [2 /*return*/];
                    }
                    isLoggedIn = loggedIn;
                    return [4 /*yield*/, loadActivityData()];
                case 13:
                    loadedActivityMeta = _l.sent();
                    _l.label = 14;
                case 14: return [3 /*break*/, 20];
                case 15:
                    if (!shareCode) return [3 /*break*/, 18];
                    hyphenatedCode = formatShareCode(shareCode);
                    return [4 /*yield*/, fetchShareCodeData(hyphenatedCode)];
                case 16:
                    shareData = _l.sent();
                    metaUrl = (_f = shareData === null || shareData === void 0 ? void 0 : shareData.meta) === null || _f === void 0 ? void 0 : _f.url;
                    if (metaUrl && metaUrl !== window.location.pathname) {
                        passiveMarker = passiveCheckedRef.current ? '&passive_checked=1' : '';
                        window.location.href = "".concat(window.location.origin).concat(metaUrl, "?").concat(hyphenatedCode).concat(passiveMarker);
                        return [2 /*return*/];
                    }
                    setShareCode(shareCode);
                    contentType = 'shared';
                    return [4 /*yield*/, Promise.all([
                            checkAuth(),
                            loadActivityData(new ShareCodeDataSource(shareCode, { canvasWidth: canvasWidth, canvasHeight: canvasHeight })),
                        ])];
                case 17:
                    _c = _l.sent(), loggedIn = _c[0], meta = _c[1];
                    isLoggedIn = loggedIn;
                    loadedActivityMeta = meta;
                    return [3 /*break*/, 20];
                case 18: return [4 /*yield*/, Promise.all([checkAuth(), loadActivityData()])];
                case 19:
                    _d = _l.sent(), loggedIn = _d[0], meta = _d[1];
                    isLoggedIn = loggedIn;
                    loadedActivityMeta = meta;
                    _l.label = 20;
                case 20: return [4 /*yield*/, fetchCardDecks(isLoggedIn)];
                case 21:
                    _l.sent();
                    setJsonDataLoaded(true);
                    return [4 /*yield*/, fetchData('./assets/data/image.json')];
                case 22:
                    _imageData = _l.sent();
                    preloadImages = (_g = _imageData === null || _imageData === void 0 ? void 0 : _imageData.preload) !== null && _g !== void 0 ? _g : {};
                    postloadImages = (_h = _imageData === null || _imageData === void 0 ? void 0 : _imageData.postload) !== null && _h !== void 0 ? _h : {};
                    criticalPromises = Object.values(preloadImages).map(function (path) {
                        return preloadAsBlob(path).catch(function () { return undefined; });
                    });
                    trayCounterUrls = ((_j = loadedActivityMeta === null || loadedActivityMeta === void 0 ? void 0 : loadedActivityMeta.trayCounters) !== null && _j !== void 0 ? _j : [])
                        .flatMap(function (tc) { return [tc.frontImage, tc.primaryImage, tc.backImage]; })
                        .filter(function (u) { return !!u; });
                    for (_i = 0, _e = Array.from(new Set(trayCounterUrls)); _i < _e.length; _i++) {
                        url = _e[_i];
                        criticalPromises.push(preloadAsBlob(url).catch(function () { return undefined; }));
                    }
                    _l.label = 23;
                case 23:
                    _l.trys.push([23, 25, , 26]);
                    return [4 /*yield*/, fetchData('./assets/data/audios.json')];
                case 24:
                    _audioObject = _l.sent();
                    initializeAudio(_audioObject);
                    return [3 /*break*/, 26];
                case 25:
                    error_1 = _l.sent();
                    console.warn('Failed to load audios.json:', error_1);
                    initializeAudio({});
                    return [3 /*break*/, 26];
                case 26: return [4 /*yield*/, Promise.all(criticalPromises)];
                case 27:
                    _l.sent();
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                case 28:
                    _l.sent();
                    setGameLoaded(true);
                    slug = window.location.pathname.replace(/^\/+/, '').replace(/\/+$/, '');
                    code = shareCode ? formatShareCode(shareCode) : '';
                    activityRef = code || slug || (loadedActivityMeta === null || loadedActivityMeta === void 0 ? void 0 : loadedActivityMeta.activityId) || 'home';
                    trackEvent(AnalyticsCategory.content, 'open', "".concat(contentType, ":").concat(activityRef));
                    paths = Object.values(postloadImages);
                    CONCURRENCY = 2;
                    POSTLOAD_START_DELAY_MS = 2000;
                    idle = (_k = window.requestIdleCallback) !== null && _k !== void 0 ? _k : (function (cb) { return setTimeout(cb, 200); });
                    setTimeout(function () {
                        idle(function () {
                            var i = 0;
                            var runNext = function () {
                                if (i >= paths.length)
                                    return;
                                preloadAsBlob(paths[i++])
                                    .catch(function () { return undefined; })
                                    .finally(function () { return setTimeout(runNext, 0); });
                            };
                            for (var n = 0; n < CONCURRENCY; n++)
                                runNext();
                        });
                    }, POSTLOAD_START_DELAY_MS);
                    return [2 /*return*/];
            }
        });
    }); };
    var FocusInsideLock = MoveFocusInside;
    return (_jsx(FocusInsideLock, { children: _jsxs("div", { id: "game-wrapper", className: "mainPlayer iconZoomLevel_".concat(playerIconZoom === 1 ? 1 : playerIconZoom === 1.5 ? 2 : 3, " display_").concat(displayMode, " contrast_").concat(contrast), children: [!fontLoad && _jsx(FontPreloader, { onFontLoad: function () { return setFontLoad(!fontLoad); } }), showLoader && (_jsx("div", { id: "loader", style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'white',
                    }, children: _jsx("img", { ref: loaderImgRef, src: getImageSrc('./assets/images/loader.gif'), alt: "loader", width: 123, height: 144, style: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            msTransform: 'translate(-50%, -50%)',
                            transform: 'translate(-50%, -50%)',
                        } }) }, "loader")), jsonDataLoaded && (_jsxs(DataContextProvider, { children: [_jsx(GameController, { displayNone: !gameLoaded }), _jsx(IwbSharePopup, {})] })), isBusy && (_jsxs(_Fragment, { children: [_jsx("div", { "aria-hidden": "true", inert: true, style: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                                zIndex: 99999,
                                pointerEvents: 'all',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }, children: _jsx("img", { src: getImageSrc('./assets/images/loader.gif'), alt: "", width: 123, height: 144, "aria-hidden": "true" }) }, "busyOverlay"), _jsx("div", { role: "status", "aria-live": "polite", className: "srOnly", children: t('text.loading', { defaultValue: 'Loading' }) })] }))] }) }));
};
export default PlayerMainContainer;
